export default "__VITE_ASSET__DGIWAAr$__"